module.exports = __webpack_public_path__ + "static/media/firma_peger.0deb03b2.jpg";